import { CONFIG } from '../utils/config';

export interface NavLink {
  name: string;
  icon: string;
  href: string;
}

export interface NavLinkWithSubmenu extends NavLink {
  submenuId: string;
  submenu: { name: string; href: string; state?: object}[];
}

export type Link = NavLink | NavLinkWithSubmenu;

export interface Section {
  sectionTitle?: string | null;
  links: Link[];
}

export const navItemsAdmin: Section[] = [
  {
    sectionTitle: null,
    links: [{ name: 'Αρχική', icon: 'bi-house', href: CONFIG.urls.getDashboardUrl_Admin() }],
  },
  {
    sectionTitle: 'ΟΝΤΟΤΗΤΕΣ & ΠΡΟΣΩΠΙΚΟ',
    links: [
      {
        name: 'Οντότητες',
        icon: 'bi-box',
        href: '#submenuOntotites',
        submenuId: 'submenuOntotites',
        submenu: [
          { name: 'Όλες', href: CONFIG.urls.getOntotitaUrl_Admin() },
          { name: 'Νέα', href: CONFIG.urls.getOntotitaAddUrl_Admin(), state: { id: "-1" }  },
        ],
      },
      {
        name: 'Πρόσωπα',
        icon: 'bi-box-seam',
        href: '#submenuStaff',
        submenuId: 'submenuStaff',
        submenu: [
          { name: 'Όλα', href: CONFIG.urls.getPersonsUrl_Admin() },
          { name: 'Νέο', href: CONFIG.urls.getPersonsAddUrl_Admin() },
        ],
      },
    ],
  },
  {
    sectionTitle: 'ΣΥΣΤΗΜΑ',
    links: [
      {
        name: 'Χρήστες',
        icon: 'bi-person-bounding-box',
        href: '#submenuUser',
        submenuId: 'submenuUser',
        submenu: [
          { name: 'Όλοι', href: CONFIG.urls.getUsersUrl_Admin() },
          { name: 'Νέος', href: CONFIG.urls.getUsersAddUrl_Admin() },
        ],
      },
      { name: 'Ρυθμίσεις', icon: 'bi-gear-wide-connected', href: '#' },
      { name: 'Αρχεία καταγραφής', icon: 'bi-files-alt', href: '#' },
    ],
  },
];



export const navItemsUser: Section[] = [
  {
    sectionTitle: null,
    links: [{ name: 'Αρχική', icon: 'bi-house', href: CONFIG.urls.getDashboardUrl_Admin() }],
  },
  {
    sectionTitle: 'ΟΝΤΟΤΗΤΕΣ & ΠΡΟΣΩΠΙΚΟ',
    links: [
      {
        name: 'Οντότητες',
        icon: 'bi-box',
        href: '#submenuOntotites',
        submenuId: 'submenuOntotites',
        submenu: [
          { name: 'Όλες', href: CONFIG.urls.getOntotitaUrl_Admin() },
        
        ],
      },
      {
        name: 'Πρόσωπα',
        icon: 'bi-box-seam',
        href: '#submenuStaff',
        submenuId: 'submenuStaff',
        submenu: [
          { name: 'Όλα', href: CONFIG.urls.getPersonsUrl_Admin() },
          { name: 'Νέο', href: CONFIG.urls.getPersonsAddUrl_Admin() },
        ],
      },
    ],
  }
];

